import type { ITotalSummary } from '../../interfaces/src/bff-web/billing';
import type { IOrder } from '../../interfaces/src/bff-web/billing/interfaces/orderV2';
import { CencopayMethod } from '../../interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';
import { calculateCouponProductsDiscountsAmount } from '../../utils/calculate-discounts-amount';
import { formatPrice } from '../utils';

import {
  getPaymentDetails,
  getSuccessInteractions,
  hasCencoPrice
} from './utils';

const getTotalSummary = (order: IOrder): ITotalSummary => {
  const deliveryGroups = order?.deliveryInfo?.deliveryGroups;
  const lineItems = order?.lineItems;
  const isCencoPrice = deliveryGroups?.some((deliveryGroup) =>
    hasCencoPrice(deliveryGroup, lineItems)
  );

  // payments is an array but always has one element
  if (!order?.payments) return {} as ITotalSummary;
  const payment = order?.payments[0];

  const interfaceInteractions = getSuccessInteractions(order);
  const paymentDetails = getPaymentDetails(interfaceInteractions, payment);
  const successList = paymentDetails?.filter((detail) => detail !== undefined);

  const paymentMethodName = successList[0]?.bankCardType;

  const hasCouponApplied = !!order?.discountCodes?.length;
  const productCouponDiscount = calculateCouponProductsDiscountsAmount(
    order?.lineItems,
    hasCouponApplied
  );

  const deliveryTotalPrice = order?.deliveryInfo?.totalPrice?.centAmount;

  const subTotalPrice =
    order?.totalPrice?.centAmount - deliveryTotalPrice + productCouponDiscount;

  const giftCard = successList?.find((elm) => {
    return elm?.type === 'GIFT_CARD';
  });

  const totalPrice = order?.totalPrice?.centAmount;
  const totalDeliveryPrice = deliveryTotalPrice
    ? formatPrice(deliveryTotalPrice)
    : '';

  const totalPriceOutput = totalPrice ? formatPrice(totalPrice) : '';
  const subTotalPriceOutput = subTotalPrice
    ? formatPrice(subTotalPrice)
    : totalPriceOutput;

  const giftCardAmount = giftCard?.amount ? Number(giftCard?.amount) : 0;

  const totalPricePlusGiftCard = totalPrice - giftCardAmount;

  const summary = {
    isCencoPayPrice: false,
    subTotalPrice: subTotalPriceOutput,
    totalDeliveryPrice: totalDeliveryPrice,
    totalCouponPrice: formatPrice(-productCouponDiscount),
    totalPriceGiftCard: giftCard?.amount ? formatPrice(giftCardAmount) : '',
    totalPrice: totalPricePlusGiftCard
      ? formatPrice(totalPricePlusGiftCard)
      : '$0',
    unformattedTotalPrice: totalPrice - giftCardAmount,
    currency: order?.totalPrice?.currencyCode,
    totalTax: order?.taxedPrice?.totalTax?.centAmount,
    wasPaidWithCencoPayBalance:
      paymentMethodName === CencopayMethod.CENCOPAY_SALDO,
    wasPaidOnlyWithGiftCard: giftCardAmount === totalPrice,
    isCencoPrice
  };

  return {
    paymentMethod: successList,
    summary: summary
  };
};

export default getTotalSummary;
